module.exports = __webpack_public_path__ + "img/26_227.baef55d3.png";